import React, { Component, Fragment } from "react";
import { AvForm, AvField, AvGroup } from "availity-reactstrap-validation";
import {
	Row,
  CustomInput,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Label, Badge,
  Card, CardHeader, Table, Media,  InputGroup, InputGroupAddon
} from "reactstrap";
import IntlMessages from "../../helpers/IntlMessages";
import { Colxx, Separator } from "../../components/common/CustomBootstrap";
import swal from 'sweetalert';
import moment from 'moment';

import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

import { zeroPad, getCurrencySymbol, getCustomerWord } from "../../helpers/Utils";
import {REST_API_END_POINT, REST_API_BASE_URL, dataEncryptKey,JQUERY_MODULE, ENQUIRY_STATUS, BASE_URL } from "../../constants/defaultValues";
import axios from 'axios';
import SimpleCrypto from "simple-crypto-js";
import number_format from "number_format-php";
import ViewFileModal from "../../components/common/ViewFileModal";
import EditReplyModal from "./EditReplyModal";
var dataCrypto = new SimpleCrypto(dataEncryptKey);
const customerWord = getCustomerWord();

const quillModules = {
  toolbar: [
    [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
	["bold", "italic", "underline"],
     // dropdown with defaults from theme	
	[
      { list: "ordered" },
      { list: "bullet" },
      { indent: "-1" },
      { indent: "+1" }
    ],    	    
    
  ]
};

const quillFormats = [
  "header",
  "bold",
  "italic",
  "underline", 
  "list",
  "bullet",
  "indent", 
];

export default class ViewModal extends Component{
	constructor(props) {
		super(props);
		
		this.state = {
			enquiry_data: null,
			facility_data: null,
			replies: [],
			currencies: [],
			textQuillStandart:"",
			showFile:true,
			doc_url:null,
			modalOpenEditReply:false,
		};
		
		this.dataListRender = this.dataListRender.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.deleteReply = this.deleteReply.bind(this);
		this.deleteReplyFile = this.deleteReplyFile.bind(this);
		this.toggleModalViewDoc = this.toggleModalViewDoc.bind(this);
	
    }
	
	toggleModalViewDoc = (e,doc_url=null) => {
		this.setState({
			modalOpenViewDoc: !this.state.modalOpenViewDoc,
			doc_url
		});
	};

	editReply= (reply_id,body) => {
		
		
		this.setState({
			modalOpenEditReply: !this.state.modalOpenEditReply,
			reply_id:reply_id,
			editBody:body,
			enquiry_id:this.state.enquiry_id
			
		});
	};
	handleChangeQuillStandart = (textQuillStandart) => {
        this.setState({ textQuillStandart });
    }	
	
	onMultiFileChange = e => {
		switch (e.target.name){
			case 'files[]':
			if(e.target.files[0]){
				var filenames_obj=e.target.files;
				var filenames=[];
				for (var i = 0; i < filenames_obj.length; i++) {
					filenames.push(filenames_obj[i].name);
				}
				e.target.parentNode.getElementsByClassName('custom-file-label')[0].innerHTML=filenames.join(',');
			}else{
				e.target.parentNode.getElementsByClassName('custom-file-label')[0].innerHTML='Choose file';
			}
		}
	};
	
	componentDidUpdate(prevProps, prevState, snapshot){
        if(this.props.modalOpen){				
            if (prevProps.enquiry_id!== this.props.enquiry_id && this.props.enquiry_id!=0) {
				this.dataListRender();
            }
        }
    }
	
	dataListRender() {
		this.setState({ showFile:false });
		var facility_id = localStorage.getItem('facility_id');
		facility_id =  dataCrypto.decrypt(facility_id);
		var formData = new FormData();
		formData.append('enquiry_id',this.props.enquiry_id);
		formData.append('facility_id',facility_id);
		axios.post(REST_API_END_POINT+'enquiries/view-order',formData).then((res)=>{
			
			var data = res.data;
			if(data.status==1){
				this.setState({ 
					enquiry_data:data.enquiry_data,
					facility_data:data.facility_data,
					replies:data.replies,
					textQuillStandart:"",
					showFile:true
				});
			}else{
				this.props.toggleModal();
				swal("Warning!","There is no such enquiry","warning");
			}					
		}).catch(e =>{
			console.log("Addition failed , Error ", e);
		}); 
	}
	
	handleSubmit(event, errors, values) {
		
		if (errors.length === 0) {
		
			if(this.state.textQuillStandart.length==0){
				swal("Warning!","Please enter the note","warning");
				return;
			}
			
			document.getElementById("reply-order").disabled=true;
			
			var user_id = localStorage.getItem('user_id');
			var facility_id = localStorage.getItem('facility_id');
			facility_id =  dataCrypto.decrypt(facility_id);
			
			var formData = new FormData(document.getElementById("replyForm"));
			formData.append('facility_id',facility_id);
			formData.append('user_id',user_id);
			formData.append('enquiry_id',this.props.enquiry_id);
			formData.append('body',this.state.textQuillStandart);

			axios.post(REST_API_END_POINT+'enquiries/order-reply',formData).then((res)=>{
				var data = res.data;
				
				var api_message=document.getElementById("api_message_documents");
				api_message.innerHTML="<div class=\"rounded alert alert-success alert-dismissible fade show\" role=\"alert\"><button type=\"button\" class=\"close\" aria-label=\"Close\"><span aria-hidden=\"true\">×</span></button><span>"+data.msg+"</span></div>";
				
				window.setTimeout(function() {
					JQUERY_MODULE.$(".alert").fadeTo(500, 0).slideUp(500, function(){
						JQUERY_MODULE.$(this).remove();
					});
				}, 5000);
				
				JQUERY_MODULE.$('.alert .close').on("click", function(e){
					JQUERY_MODULE.$(this).parent().fadeTo(500, 0).slideUp(500, function(){
						JQUERY_MODULE.$(this).remove();
					});
				});
				
				document.getElementById("reply-order").disabled=false;
				this.form && this.form.reset();
				this.dataListRender();

			}).catch(e =>{
				console.log("Addition failed , Error ", e);
				document.getElementById("reply-order").disabled=false;
			});

		}
	}
		
	deleteReply = (reply_id)  => {
		var msg="Delete this note?";
        
        swal({
          title: "Are you sure?",
          text: msg,
          icon: "warning",
          buttons: true,
          dangerMode: true,
        })
		.then((willDelete) => {
			if (willDelete) {
				var facility_id = localStorage.getItem('facility_id');
				facility_id =  dataCrypto.decrypt(facility_id);
				
				var user_id = localStorage.getItem('user_id');
				var formData = new FormData();
				formData.append('reply_id',reply_id);
				formData.append('user_id',user_id);
				formData.append('facility_id',facility_id);
				
				axios.post(REST_API_END_POINT+'enquiries/delete-reply',formData).then((res)=>{
					var data = res.data;
					if(data.status==1){
						var replies = this.state.replies;
						replies = replies.filter(r=>{ return r.ID!=reply_id });
						this.setState({ replies })
						swal("Success",data.msg,"success");
					}else{
						swal("Failed",data.msg,"warning");
					}
					
				}).catch(e =>{
					console.log("Addition failed , Error ", e);
				});				
			}else{
				swal("Your operation is canceled!");
			}
		});
	}
	
	deleteReplyFile = (file_id)  => {
		var msg="Delete this file?";
        
        swal({
          title: "Are you sure?",
          text: msg,
          icon: "warning",
          buttons: true,
          dangerMode: true,
        })
		.then((willDelete) => {
			if (willDelete) {
				var facility_id = localStorage.getItem('facility_id');
				facility_id =  dataCrypto.decrypt(facility_id);
				
				var user_id = localStorage.getItem('user_id');
				var formData = new FormData();
				formData.append('file_id',file_id);
				formData.append('user_id',user_id);
				formData.append('facility_id',facility_id);
				
				axios.post(REST_API_END_POINT+'enquiries/delete-reply-file',formData).then((res)=>{
					var data = res.data;
					if(data.status==1){
						var replies = this.state.replies;
						replies = replies.map(r=>{
							r.files = r.files.filter(f=>{ return f.ID!=file_id });
							return r;
						})
						this.setState({ replies })
						swal("Success",data.msg,"success");
					}else{
						swal("Failed",data.msg,"warning");
					}
					
				}).catch(e =>{
					console.log("Addition failed , Error ", e);
				});				
			}else{
				swal("Your operation is canceled!");
			}
		});
	}
	
    render() {
		const { enquiry_data, replies, currencies, facility_data } = this.state;
		var current_currency_symbol = getCurrencySymbol();
		var status_text ="";
		var status_badge ="";
		if(enquiry_data!=null){
			const order_status = ENQUIRY_STATUS.find(r=>{ return r.value==enquiry_data.status });
			if(order_status!=null){
				status_text = order_status.label;
				status_badge = <Badge color={order_status.badge} >{order_status.label}</Badge>;
			}
		}
		
		return (
			<Modal
			  isOpen={this.props.modalOpen}
			  toggle={this.props.toggleModal}
			  wrapClassName="modal-right modal-right-lg"
			  size="md"
			>
				<ModalHeader toggle={this.props.toggleModal}>
					View Enquiry
				</ModalHeader>
					
				<ModalBody >
					{enquiry_data!=null ? <Fragment>
						<Row>
							<Colxx md="7">
								<div className="view-order-table">
									<div className="font-weight-bold text-uppercase h4">#{moment(enquiry_data.timestamp*1000).format('YYYY')}/{zeroPad(enquiry_data.order_number,6)}</div>
									<div className="border-bottom pt-2 mb-3" />
									<Table responsive bordered>
										<thead>
											<tr>
												<th className="mb-2">#</th>						
												<th className="mb-2">Product</th>
												<th className="mb-2 text-right">Quantity</th>	
												<th className="mb-2 text-right">Price</th>
												
											</tr>
										</thead>
										<tbody>
											{enquiry_data.enquiry_products.map((row,index)=>{
												return(<tr key={index}>
												<td>{index+1}</td>
												<td>{row.product_name}</td>
												<td className="text-right">{number_format(parseFloat(row.quantity),2,'.','')}</td>
											    <td className="text-right">{number_format(parseFloat(row.unit_price),2,'.','')}</td>
												
											</tr>)
											})}
										</tbody>
									</Table>
								</div>
							</Colxx>
							<Colxx md="5">
								<Media>
									<Media left className="mr-2">
										<Media object width="50" src={enquiry_data.client_avatar!=null ? REST_API_BASE_URL+"uploads/users/"+enquiry_data.client_avatar:REST_API_BASE_URL+"uploads/users/avatar.jpg"} alt={enquiry_data.vendor_name} />
									</Media>
									<Media body>
										<p className="mb-1">{customerWord} Name: {enquiry_data.vendor_name}</p>
										<p className="mb-1">Created: {moment(enquiry_data.timestamp*1000).format('YYYY-MM-DD')}</p>
										{/* <p className="mb-1">Expiry Date: {enquiry_data.expiry_date}</p> */}
										<p className="mb-1">Age of Enquiry: {enquiry_data.age}</p>
										{enquiry_data.reason?<p className="mb-1">Reason: {enquiry_data.reason}</p>:""}
										<p className="mb-1">Status: {status_badge}</p>
										{enquiry_data.ap_username!=null ? <p className="mb-1">Added By: {enquiry_data.ap_username}</p>:""}		
										{enquiry_data.up_username!=null ?enquiry_data.status==3? <p className="mb-1">Accepted By: {enquiry_data.up_username}</p>:enquiry_data.status==4? <p className="mb-1">Rejected By: {enquiry_data.up_username}</p>:"":""}									
										{enquiry_data.cp_username!=null ? <p className="mb-1">Converted to Estimate & Quotation By: {enquiry_data.cp_username}</p>:""}		
									</Media>
								</Media>
								<div className="border-bottom pt-2 mb-3" />								
							</Colxx>
						</Row>
						
						{replies.length ? <hr/>:""}
						{replies.length ? <Row>
							{console.log("enquiry_data",enquiry_data)}
							
							<Colxx md="12">
								<div className="font-weight-bold h5">Notes</div>
								
								{replies.map(row=>{
									return(<Card className="p-3 mb-3">
									<Row>
										<Colxx md="4">
											<Media>
												<Media left className="mr-2">
													<Media object width="50" src={row.profile_pic!="" ? REST_API_BASE_URL+"uploads/users/"+row.profile_pic:REST_API_BASE_URL+"uploads/users/avatar.jpg"} alt={row.username} />
												</Media>
												<Media body>
													<p className="mb-1">{row.username}</p>
													<p className="mb-1">Created At {moment(row.timestamp*1000).format('MM/DD/YYYY hh:mm a')}</p>
												{row.updated_at!=0?	<p className="mb-1">Updated At {moment(row.updated_at*1000).format('MM/DD/YYYY hh:mm a')}</p>:""}
												</Media>
											</Media>
										</Colxx>
										<Colxx md="8">
											<div className="float-right">
											<Button size="sm" color="danger" className="py-1 px-2  m-2" onClick={()=>{ this.editReply(row.ID,row.body) }} ><i className="simple-icon-pencil" /></Button>
												<Button size="sm" color="danger" className="py-1 px-2" onClick={()=>{ this.deleteReply(row.ID) }} ><i className="far fa-trash-alt" /></Button></div>
											<div dangerouslySetInnerHTML={{__html: row.body}} />
											
											{row.files.length ? <Table hover responsive>										
												<tbody>
													{row.files.map((r,index)=>{
														return(<tr key={index}>
														<td><p className="name mb-0"><span className="open-document btn-link cursor-pointer" onClick={(e)=>{ this.toggleModalViewDoc(e,BASE_URL+'customers/'+r.upload_file_name) }}>{r.upload_file_name}</span></p></td>
														<td>{r.file_size} KB</td>
														{/*<td><Button size="sm" color="danger" className="py-1 px-2" onClick={()=>{ this.deleteReplyFile(r.ID) }} ><i className="far fa-trash-alt" /></Button></td>*/}
													</tr>)
													})}
												</tbody>
											</Table>:""}
										</Colxx>
									</Row>
									</Card>);
								})}
							</Colxx>
						</Row>:""}
						
						<hr/>
						<Row>
						{enquiry_data.status!=8 ?
						<Colxx md="10">
								<div className="font-weight-bold h5">Add Note</div>
								
								<AvForm
									id="replyForm"
									ref={c => (this.form = c)}
									className="av-tooltip tooltip-right-bottom"
									onSubmit={this.handleSubmit}
								>
									<Row className="mt-3">
										<Colxx lg="12" className="mb-2">
											<AvGroup>
												<Label>Message Body<span className="text-danger">*</span></Label>
												<ReactQuill
													theme="snow"
													name="body"
													value={this.state.textQuillStandart}
													onChange={this.handleChangeQuillStandart}
													placeholder=""
													modules={quillModules}
													formats={quillFormats}
												/>
											</AvGroup>
										</Colxx>
									</Row>
									{this.state.showFile ? <Row>
										<Colxx lg="12" className="mb-2">
											<AvGroup className="error-l-125 error-t-negative">
												<Label>Attach Files</Label>
												<InputGroup className="mb-3">
													<InputGroupAddon addonType="prepend">Upload</InputGroupAddon>
													<CustomInput
														type="file"
														name="files[]"
														id="test_document"
														multiple 
														onChange={this.onMultiFileChange}
													/>
												</InputGroup>
											</AvGroup>
										</Colxx>
									</Row>:""}
									
									<Row className="mt-2 mb-4">
										<Colxx xxs="12">
											<Button	id="reply-order" color="primary" >Submit</Button>
										</Colxx>
									</Row>									
								</AvForm>
								<div id="api_message_documents"></div>
							</Colxx>:""}
						</Row>
					</Fragment>:""}
					{this.state.doc_url!=null ? <ViewFileModal 
						modalOpen={this.state.modalOpenViewDoc}
						toggleModal={this.toggleModalViewDoc}
						doc_url={this.state.doc_url}
					/>:""}
						{this.state.modalOpenEditReply? <EditReplyModal 
						modalOpen={this.state.modalOpenEditReply}
						toggleModal={this.editReply}
						replyId={this.state.reply_id}
						editBody={this.state.editBody}
						enquiry_id={this.state.enquiry_id}
						dataListRender={this.dataListRender}
					
					/>:""}
				</ModalBody>
				<ModalFooter>
					<Button color="secondary" outline onClick={this.props.toggleModal}>
						<IntlMessages id="customer.close" />
					</Button>{" "}
				</ModalFooter>
			</Modal>
		);
  }
};
